import { call, put, retry } from 'redux-saga/effects';
import { ApplePayWalletExtension } from '@nbx/capacitor-apple-pay';
import { setLastBioAuthenticatedEpochMs, writeDeviceToken } from '@nbx/frontend-helpers/auth';
import { NBXAuth } from 'services';

import ERRORS from 'constants/errors';
import { getUser, setError, setIds } from 'reduxConfig/auth.creators';

export function* verifyLoginGetSession({
  email,
  idToken,
  twoFactorCode,
  useRecoveryCode,
  forceRefreshIdToken,
  isRetry = false
}) {
  if (!email) {
    const user = yield call(window.FIREBASE.user);
    if (!user) yield put(setError(ERRORS.userLoginVerifyError));
    email = user?.email;
  }

  if (!idToken) {
    idToken = yield call(window.FIREBASE.getIdTokenFromNative, forceRefreshIdToken);
  }

  const verifyResponse = yield retry(
    isRetry ? 15 : 1,
    1000,
    NBXAuth.verify,
    idToken,
    twoFactorCode,
    useRecoveryCode
  );

  // if there is no session on authservice it throws an error that is catched in the next authVerifyLogin

  let session;
  if (window.PLATFORM === 'web') {
    session = verifyResponse;
  } else {
    const deviceTokenResponse = JSON.stringify(verifyResponse);
    yield call(writeDeviceToken, { deviceTokenResponse });
    if (window.PLATFORM === 'ios') {
      yield call(ApplePayWalletExtension.writeDeviceToken, deviceTokenResponse);
    }
    yield call(setLastBioAuthenticatedEpochMs);
    session = yield retry(isRetry ? 15 : 1, 1000, NBXAuth.verifyDevice, verifyResponse.token);
  }

  yield call(window.GET_ACCOUNT_TOKEN, session, session.accountId);
  yield put(setIds(session.userId, session.accountId));
  yield put(getUser(session.userId, session.claims, email));

  yield call(window.MESSAGING.setup);
}
